
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collectives/[collectiveId]",
      function () {
        return require("private-next-pages/collectives/[collectiveId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collectives/[collectiveId]"])
      });
    }
  